// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const inkay: PokeData = {
  "id": 686,
  "name": "inkay",
  "height": 4,
  "weight": 35,
  "base_experience": 58,
  "types": [
    PokeType.DARK,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "wrap",
    "psybeam",
    "peck",
    "hypnosis",
    "light-screen",
    "reflect",
    "constrict",
    "psywave",
    "slash",
    "swagger",
    "superpower",
    "pluck",
    "payback",
    "night-slash",
    "switcheroo",
    "psycho-cut",
    "foul-play",
    "topsy-turvy"
  ],
  "moves": [
    "tackle",
    "peck",
    "reflect",
    "psywave",
    "superpower",
    "night-slash",
    "psychic",
    "bite",
    "zen-headbutt",
    "prismatic-cage",
    "healing-wish",
    "dark-bargain",
    "psy-ball"
  ],
  "evolution_chain": {
    "id": 352,
    "item": null,
    "species": [
      {
        "name": "inkay",
        "order": 687,
        "types": [
          PokeType.DARK,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "malamar",
        "order": 688,
        "types": [
          PokeType.DARK,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 686,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": true,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 51.25,
    "speed": 45,
    "ability_power": 54
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
